import { result } from 'validate.js';

function getSessionIdFromCookieOrStorage() {
  const cookieMatch = /(?:^|; )session_id=([^;]*)/.exec(document.cookie);
  const cookieSessionId = cookieMatch?.[1] ? decodeURIComponent(cookieMatch[1]).trim() : '';

  if (cookieSessionId && cookieSessionId !== 'undefined' && cookieSessionId !== 'null') {
    return cookieSessionId;
  }

  const storageSessionId = localStorage.getItem('session_id');
  if (storageSessionId && storageSessionId !== 'undefined' && storageSessionId !== 'null') {
    return storageSessionId;
  }

  return null;
}

export default function deleteFromVIDAADB(id, uiNotificationService) {
  console.log('Delete fromVIDAA db, add to VIDAADB script');
  deleteMeasurement(id).then(result => {
    console.log('Delete measurement result', result);
     uiNotificationService.show({
        title: 'Measurement Deleted',
        message: `The measurement is deleted correctly.`,
        type: 'success',
        duration: 5000,
      });
  }). catch(error => {
     uiNotificationService.show({
        title: 'Error Deleting Measurement',
        message: `There was a problem deleting the measurement. ${error}`,
        type: 'error',
        autoClose: false,
      });
  }
  );
}

async function deleteMeasurement(id) {

  // Get the value of a parameter
  // const token = urlParams.get('vidaatoken');
  const API_URL_ENV = process.env.API_URL;
  const API_URL = `${API_URL_ENV}/annotations/image-annotation/${id}`;

  const viewer_token_raw = sessionStorage.getItem('session_viewer');
  const viewer_token =
    viewer_token_raw && viewer_token_raw !== 'undefined' && viewer_token_raw !== 'null'
      ? viewer_token_raw
      : null;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  if (viewer_token) {
    myHeaders.append('Authorization', `Bearer ${viewer_token}`);
  }
 const session_id = getSessionIdFromCookieOrStorage();
        if (session_id) {
          myHeaders.append('x-api-key', session_id);
        }

  const options = {
    method: 'DELETE',
    headers: myHeaders,
    credentials: 'include' as RequestCredentials,
  };
  // console.log(JSON.stringify(measurementData));
  // Await the fetch call and return the parsed JSON response
  const response = await fetch(API_URL, options);
  // console.log(response);
  if (!response.ok) {
    throw new Error(
      `${response.status}: ${response.statusText}`
    );
  }
  return response;
}
